import { HTTP_INTERCEPTORS } from "@angular/common/http";
import { RequestInterceptor } from "./request.interceptor.service";
import { TokenInterceptorService } from "./token-inteceptor.service";


export const interceptorProviders = [
    { provide: HTTP_INTERCEPTORS, useClass: TokenInterceptorService, multi: true, },
    { provide: HTTP_INTERCEPTORS, useClass: RequestInterceptor, multi: true, }
];
